module.exports = __webpack_public_path__ + "img/Social-1000Blocks-Discord.e347c372.png";